// extracted by mini-css-extract-plugin
export var closeButton = "_jv-1";
export var closeX = "_jv-3";
export var container = "_jv-0";
export var image = "_jv-2";